import * as ngCommon from '@angular/common'
import * as ngCore from '@angular/core'

/** Displays object value  */
@ngCore.Component({
  imports: [ngCommon.KeyValuePipe],
  selector: 'atn-object-content',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** Object content to be displayed */
  public readonly valueSg = ngCore.input.required<Record<string, unknown>>({
    alias: 'value',
  })
}
